export default {
      id: "helpOutline-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#helpOutline-usage",
      toString: function () {
        return this.url;
      }
    }